import { axiosInstanceToken, axiosInstance, resolvePromise } from "../utils/axios";
import { daoRoute } from "../utils/config";

let app = {
	getConfig(url) {
		return new Promise(function(resolve, reject) {
			const getConfigUrl = daoRoute.app.getConfig.replace(":url", url);

			resolvePromise(axiosInstance.get(getConfigUrl), resolve, reject);
		});
	},
	getI18n(baseName, language) {
		return new Promise(function(resolve, reject) {
			const getI18nUrl = daoRoute.app.getI18n
				.replace(":baseName", baseName)
				.replace(":locale", language);

			resolvePromise(
				axiosInstance.get(getI18nUrl),
				resolve,
				reject
			);
		});
	},
	getAnnouncement() {
		return new Promise(function(resolve, reject) {
			const getAnnouncementUrl = daoRoute.app.getAnnouncement;

			resolvePromise(
				axiosInstance.get(getAnnouncementUrl),
				resolve,
				reject
			);
		});
	},
	getUserlist() {
		return new Promise(function(resolve, reject) {
			
			resolvePromise(
				axiosInstanceToken.get(daoRoute.users.getUserlist),
				resolve,
				reject
			);
		});
	},
	checkUserToken(token) {
		return new Promise(function(resolve, reject) {
			const checkAuthenticate = daoRoute.login.checkAuthenticate;

			resolvePromise(
				axiosInstanceToken.get(checkAuthenticate),
				resolve,
				reject
			);
		});
	}
};

export default app;



// WEBPACK FOOTER //
// ./src/api/appDao.js